<template>
  <div>
    <div class="flex">
      <button :disabled="uploadingAttachments" @click="sendMessage">
        SEND
      </button>
      <div class="flex-1" id="chat_input"></div>
      <button @click="showFilePicker">ATTACH FILE</button>
      <input
        @change="onFilesSelected($event.target.files)"
        multiple
        ref="hiddenAttachments"
        type="file"
        style="display: none"
      />
    </div>
    <div v-if="uploadingAttachments">Uploading attachments...</div>
    <div v-if="attachmentPreviews.length > 0">
      <div :key="preview.id" v-for="(preview, index) in attachmentPreviews">
        <img
          style="width: 32px; height: 32px; object-fit: cover"
          v-if="preview.type.startsWith('image/')"
          :src="preview.downloadURL"
          alt=""
        />
        <span
          v-else
          style="
            display: inline-block;
            width: 32px;
            height: 32px;
            background: black;
          "
        />
        <button @click="removeAttachment(index)">Remove</button>
      </div>
    </div>
  </div>
</template>

<script>
import Quill from "quill";
import "quill-mention";
import { uploadFile } from "../../FileUploadUtils";

export default {
  name: "ChatInput",
  data() {
    return {
      uploadingAttachments: false,
      attachments: [],
      editor: null,
    };
  },
  computed: {
    meetingToken() {
      return this.$store.state.meeting.meeting.token.value;
    },
    attachmentPreviews() {
      return this.attachments.map((attachment) => ({
        ...attachment,
        downloadURL: `${attachment.downloadURL}?meeting_token=${this.meetingToken}`,
      }));
    },
    participants() {
      return this.$store.state.meeting.participants.map((it) => ({
        id: it.user_id,
        value: it.user_name,
      }));
    },
  },
  mounted() {
    this.editor = new Quill("#chat_input", {
      placeholder: "Type...",
      modules: {
        mention: {
          allowedChars: /^[A-Za-z\sÅÄÖåäö]*$/,
          mentionDenotationChars: ["@"],
          source: (searchTerm, renderList, mentionChar) => {
            if (searchTerm.length === 0) {
              return renderList(this.participants, searchTerm);
            }
            const matches = this.participants.filter(
              (it) =>
                it.value.toLowerCase().indexOf(searchTerm.toLowerCase()) !== -1
            );
            renderList(matches);
          },
        },
      },
    });
  },
  methods: {
    async removeAttachment(index) {
      const attachment = this.attachments[index];
      await this.$store.dispatch("deleteAttachment", attachment.id);

      const newAttachments = [...this.attachments];
      newAttachments.splice(index, 1);
      this.attachments = newAttachments;
    },
    async onFilesSelected(files) {
      if (files.length === 0) return;
      this.uploadingAttachments = true;

      const newAttachments = [
        ...this.attachments,
        ...(await this.$store.dispatch("uploadAttachments", Array.from(files))),
      ];

      this.$refs.hiddenAttachments.value = "";
      this.uploadingAttachments = false;

      this.attachments = newAttachments;
    },

    showFilePicker() {
      this.$refs.hiddenAttachments.click();
    },
    async sendMessage() {
      const attachments = this.attachments;
      const html = this.editor.root.innerHTML;
      const text = this.editor.root.innerText;
      const mentions = Array.from(
        this.editor.root.querySelectorAll(".mention")
      ).map((el) => el.getAttribute("data-id"));

      await this.$store.dispatch("sendMessage", {
        html,
        text,
        mentions,
        attachments,
      });

      this.attachments = [];
      this.editor.setText("");
    },
  },
};
</script>

<style>
@import "~quill/dist/quill.core.css";

.ql-container {
  font-family: inherit;
}

.ql-editor.ql-blank::before {
  font-style: normal !important;
}
</style>
